import { render, staticRenderFns } from "./multilingual-components.vue?vue&type=template&id=6580e6e0"
import script from "./multilingual-components.vue?vue&type=script&lang=js"
export * from "./multilingual-components.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports